<template>
  <div>
    <div id="map"></div>
    <button @click="test()"></button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      geocoder: null,
      jipvioMap: null
    };
  },
  mounted() {
    if (window.kakao && window.kakao.maps) {
      this.initMap();
    } else {
      const script = document.createElement("script");
      /* global kakao */
      script.onload = () => kakao.maps.load(this.initMap);
      script.src = `https://dapi.kakao.com/v2/maps/sdk.js?autoload=false&appkey=${process.env.VUE_APP_KKO_SDK_KEY}&libraries=services,clusterer,drawing`;
      // <head></head>에 위치
      document.head.appendChild(script);
    }
  },
  methods: {
    test() {
      let self = this;
      this.geocoder.addressSearch("마들로", function(result, status) {
        //console.log(result);
        if (status === kakao.maps.services.Status.OK) {
          var coords = new kakao.maps.LatLng(result[0].y, result[0].x);
          self.jipvioMap.setCenter(coords);
        }
        /*
        // 정상적으로 검색이 완료됐으면
        if (status === kakao.maps.services.Status.OK) {
          var coords = new kakao.maps.LatLng(result[0].y, result[0].x);

          // 결과값으로 받은 위치를 마커로 표시합니다
          var marker = new kakao.maps.Marker({
            map: map,
            position: coords,
          });

          // 인포윈도우로 장소에 대한 설명을 표시합니다
          var infowindow = new kakao.maps.InfoWindow({
            content:
              '<div style="width:150px;text-align:center;padding:6px 0;">우리회사</div>',
          });
          infowindow.open(map, marker);

          // 지도의 중심을 결과값으로 받은 위치로 이동시킵니다
          map.setCenter(coords);
        }
        */
      });
    },
    initMap() {
      const container = document.getElementById("map");
      var options = {
        // required : 위도(latitude), 경도(longitude)
        center: new kakao.maps.LatLng(33.450701, 126.570667),
        level: 3
      };

      const map = new kakao.maps.Map(container, options);
      map.setMapTypeId(kakao.maps.MapTypeId.HYBRID);
      this.jipvioMap = map;
      this.geocoder = new kakao.maps.services.Geocoder();

      // 일반 지도와 스카이뷰로 지도 타입을 전환할 수 있는 지도타입 컨트롤을 생성합니다.
      var mapTypeControl = new kakao.maps.MapTypeControl();
      // 지도에 컨트롤을 추가해야 지도위에 표시됩니다
      // kakao.maps.ControlPosition은 컨트롤이 표시될 위치를 정의하는데 TOPRIGHT는 오른쪽 위를 의미합니다.
      map.addControl(mapTypeControl, kakao.maps.ControlPosition.TOPRIGHT);

      // 지도 확대 축소를 제어할 수 있는  줌 컨트롤을 생성합니다.
      var zoomControl = new kakao.maps.ZoomControl();
      map.addControl(zoomControl, kakao.maps.ControlPosition.RIGHT);
    }
  }
};
</script>

<style>
div#map {
  width: 500px;
  height: 400px;
}
</style>
